import Vue from 'vue'
import App from './App.vue'
// router与store
import router from './router'
import store from './store'
// 引入element
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// 全局组件
import '@/components'

// 引入外部JS
import api from './api'
import pub from './public/index.js'
import ver from './verification/index.js'
import load from './loading/loading.js'
import routerAdd from './router/router.js'

Vue.prototype.$api = api
Vue.prototype.$pub = pub
Vue.prototype.$ver = ver
Vue.prototype.$load = load
Vue.prototype.$routerAdd = routerAdd


Vue.use(ElementUI)

Vue.config.productionTip = false

if (pub.getStorage('leftnav')) {
	let rl = []
	store.state.leftNav = JSON.parse(pub.getStorage('leftnav'))
	routerAdd.getRouterList(res => {
		rl = res
	})
	router.addRoutes(rl)
}else{
	router.addRoutes([{
		path: '*',
		redirect: '/notFound'
	}])
}
if (pub.getStorage('i_token') && pub.getStorage('i_userInfo')) {
	let userInfo = JSON.parse(pub.getStorage('i_userInfo'))
	store.commit('setRealStatus', userInfo)
}

router.beforeEach((to, from, next) => {
	if (to.meta.title) {
		document.title = to.meta.title
	}
	next()
})

new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app')
